import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

// import logo from "../../assets/images/gifs/Logo Animation.gif";
import arrow from "../../assets/images/svgs/arrow.svg";
import { FaBars, FaTimes } from "react-icons/fa";
import FormSpreeForm from "../formSpreeForm";
import { REGISTER_LINK } from "../../constant";
import AltimateLogoComponent from "../companies/company_logo_animation";

const Header = () => {
  const location = useLocation();
  const [menuActive, setMenuActive] = useState(false);
  const [visibleForm, setVisibleForm] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isDocsOpen, setIsDocsOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const timeoutRef = useRef(null);
  const docsTimeoutRef = useRef(null);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      // Close mobile menu on resize to desktop
      if (window.innerWidth > 1024 && menuActive) {
        setMenuActive(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [menuActive]);

  // Close menu when route changes
  useEffect(() => {
    setMenuActive(false);
  }, [location]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (menuActive) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuActive]);

  const menuToggler = () => {
    setMenuActive(!menuActive);
  };

  // const loadForm = () => {
  //   setVisibleForm(true);
  // };

  const isFixed = true;

  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     if (window.scrollY > 10) {
  //       setIsFixed(true);
  //     } else {
  //       setIsFixed(false);
  //     }
  //   });
  // }, []);

  const handleDropdownEnter = () => {
    if (windowWidth > 1024) {
      clearTimeout(timeoutRef.current);
      setIsOpen(true);
    }
  };

  const handleDropdownLeave = () => {
    if (windowWidth > 1024) {
      timeoutRef.current = setTimeout(() => {
        setIsOpen(false);
      }, 300);
    }
  };

  const handleDropdownShow = () => {
    setIsOpen((prev) => !prev);
  };

  const handleDocsDropdownEnter = () => {
    if (windowWidth > 1024) {
      clearTimeout(docsTimeoutRef.current);
      setIsDocsOpen(true);
    }
  };

  const handleDocsDropdownLeave = () => {
    if (windowWidth > 1024) {
      docsTimeoutRef.current = setTimeout(() => {
        setIsDocsOpen(false);
      }, 300);
    }
  };

  const handleDocsDropdownShow = () => {
    setIsDocsOpen((prev) => !prev);
  };

  // Determine which items should be in mobile menu
  const showFullNav = windowWidth > 1280;
  const showMediumNav = windowWidth > 1024;
  const showCompactNav = windowWidth > 768;

  return (
    <>
      {visibleForm && <FormSpreeForm setVisibleForm={setVisibleForm} />}
      <header className={`header ${isFixed ? "header-fixed" : ""}`}>
        <div className="header-container">
          <div className="header-content">
            {/* Logo */}
            <Link to="/" className="header-logo">
              {/* <img src={logo} className="h-[32px]" alt="logo" /> */}
              <AltimateLogoComponent />
            </Link>

            {/* Desktop Navigation */}
            {showMediumNav && (
              <nav className="desktop-nav">
                <ul className="nav-list">
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        `nav-link ${isActive || location.pathname === "/" ? "active" : ""}`
                      }
                      to="/datamates"
                    >
                      DataMates
                    </NavLink>
                  </li>
                  {showFullNav && (
                    <>
                      <li>
                        <NavLink
                          className={({ isActive }) =>
                            `nav-link ${isActive ? "active" : ""}`
                          }
                          to="/analytics"
                        >
                          Analytics Engineering
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className={({ isActive }) =>
                            `nav-link ${isActive ? "active" : ""}`
                          }
                          to="/platform"
                        >
                          Platform Engineering
                        </NavLink>
                      </li>
                    </>
                  )}
                  <li
                    className="nav-dropdown"
                    onMouseEnter={handleDocsDropdownEnter}
                    onMouseLeave={handleDocsDropdownLeave}
                  >
                    <button className="nav-link dropdown-toggle" onClick={handleDocsDropdownShow}>
                      Docs
                      <img src={arrow} className="dropdown-arrow" alt="arrow" />
                    </button>
                    <ul className={`dropdown-menu ${isDocsOpen ? "show" : ""}`}>
                      <li>
                        <a
                          href="https://datamates-docs.myaltimate.com/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          DataMates
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://docs.myaltimate.com/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Power User for dbt
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    className="nav-dropdown"
                    onMouseEnter={handleDropdownEnter}
                    onMouseLeave={handleDropdownLeave}
                  >
                    <button className="nav-link dropdown-toggle" onClick={handleDropdownShow}>
                      Resources
                      <img src={arrow} className="dropdown-arrow" alt="arrow" />
                    </button>
                    <ul className={`dropdown-menu ${isOpen ? "show" : ""}`}>
                      <li><Link to="/videos">Tutorials</Link></li>
                      <li><Link to="/pricing">Pricing</Link></li>
                      <li><Link to="/about">About us</Link></li>
                      <li><Link to="/support">Support</Link></li>
                      <li><a href="https://blog.altimate.ai/">Blog</a></li>
                      <li><Link to="/security">Security</Link></li>
                      <li><a href="https://jobs.ashbyhq.com/altimate">Careers</a></li>
                    </ul>
                  </li>
                </ul>
              </nav>
            )}

            {/* Desktop Buttons */}
            {showCompactNav && (
              <div className="header-actions">
                <a
                  href="https://calendly.com/d/cncb-mfh-wpq/demo-request-platform-cost-savings"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-secondary"
                >
                  Book a demo
                </a>
                <Link to={REGISTER_LINK} className="btn btn-primary">
                  Start for free
                </Link>
              </div>
            )}

            {/* Mobile Menu Button */}
            <button
              className={`mobile-menu-btn ${windowWidth <= 1024 ? 'show' : ''}`}
              onClick={menuToggler}
              aria-label="Toggle menu"
            >
              {menuActive ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-nav-wrapper ${menuActive ? "active" : ""}`}>
          <div className={`mobile-nav-overlay ${menuActive ? "active" : ""}`} onClick={menuToggler}></div>
          <nav className={`mobile-nav ${menuActive ? "active" : ""}`}>
            <div className="mobile-nav-header">
              <Link to="/" onClick={menuToggler}>
                <AltimateLogoComponent />
              </Link>
              <button className="mobile-close-btn" onClick={menuToggler} aria-label="Close menu">
                <FaTimes />
              </button>
            </div>
            <ul className="mobile-nav-list">
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `mobile-nav-link ${isActive || location.pathname === "/" ? "active" : ""}`
                  }
                  to="/datamates"
                  onClick={menuToggler}
                >
                  DataMates
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `mobile-nav-link ${isActive ? "active" : ""}`
                  }
                  to="/analytics"
                  onClick={menuToggler}
                >
                  Analytics Engineering
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) =>
                    `mobile-nav-link ${isActive ? "active" : ""}`
                  }
                  to="/platform"
                  onClick={menuToggler}
                >
                  Platform Engineering
                </NavLink>
              </li>
              <li>
                <div className="mobile-dropdown">
                  <button
                    className="mobile-nav-link dropdown-toggle"
                    onClick={handleDocsDropdownShow}
                  >
                    Docs
                    <img src={arrow} className={`dropdown-arrow ${isDocsOpen ? "rotate" : ""}`} alt="arrow" />
                  </button>
                  {isDocsOpen && (
                    <ul className="mobile-dropdown-menu">
                      <li>
                        <a
                          href="https://datamates-docs.myaltimate.com/"
                          target="_blank"
                          rel="noreferrer"
                          onClick={menuToggler}
                        >
                          DataMates
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://docs.myaltimate.com/"
                          target="_blank"
                          rel="noreferrer"
                          onClick={menuToggler}
                        >
                          Power User for dbt
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </li>
              <li>
                <div className="mobile-dropdown">
                  <button
                    className="mobile-nav-link dropdown-toggle"
                    onClick={handleDropdownShow}
                  >
                    Resources
                    <img src={arrow} className={`dropdown-arrow ${isOpen ? "rotate" : ""}`} alt="arrow" />
                  </button>
                  {isOpen && (
                    <ul className="mobile-dropdown-menu">
                      <li><Link to="/videos" onClick={menuToggler}>Tutorials</Link></li>
                      <li><Link to="/pricing" onClick={menuToggler}>Pricing</Link></li>
                      <li><Link to="/about" onClick={menuToggler}>About us</Link></li>
                      <li><Link to="/support" onClick={menuToggler}>Support</Link></li>
                      <li><a href="https://blog.altimate.ai/" onClick={menuToggler}>Blog</a></li>
                      <li><Link to="/security" onClick={menuToggler}>Security</Link></li>
                      <li><a href="https://jobs.ashbyhq.com/altimate" onClick={menuToggler}>Careers</a></li>
                    </ul>
                  )}
                </div>
              </li>
            </ul>
            <div className="mobile-nav-actions">
              <a
                href="https://calendly.com/d/cncb-mfh-wpq/demo-request-platform-cost-savings"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary mobile"
                onClick={menuToggler}
              >
                Book a demo
              </a>
              <Link
                to={REGISTER_LINK}
                className="btn btn-primary mobile"
                onClick={menuToggler}
              >
                Start for free
              </Link>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
